import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const startFreeTrial = () => {
    return axiosPrivate.post('dashboard/api/v1/paymob-pro-trial/')
};

export const showPaymobProDrawer = () => {
    return axiosPrivate.post('/dashboard/api/v1/paymob-pro-drawer/')
};